import { useState, useEffect } from 'react';
import { Fuel, Moon, Sun } from 'lucide-react';

export const AppHeader = ({ darkMode, onToggleDarkMode }) => {
  return (
    <header 
      data-testid="app-header"
      className="bg-white dark:bg-black border-b-4 border-black dark:border-white p-4 sticky top-0 z-50"
    >
      <div className="flex justify-between items-center">
        {/* Logo fusionné P[pompe]MPY */}
        <div className="flex items-center">
          <h1 className="font-heading text-3xl font-bold uppercase tracking-tight text-black dark:text-white flex items-center">
            <span>P</span>
            <span className="relative mx-[-2px]">
              <Fuel className="w-8 h-8 text-[#FF4500]" />
            </span>
            <span>MPY</span>
          </h1>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={onToggleDarkMode}
            data-testid="dark-mode-toggle"
            className="p-2 border-2 border-black dark:border-white bg-transparent hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
            title={darkMode ? 'Mode clair' : 'Mode sombre'}
          >
            {darkMode ? (
              <Sun className="w-5 h-5 text-white" />
            ) : (
              <Moon className="w-5 h-5 text-black" />
            )}
          </button>
          <span className="text-xs font-mono text-gray-500 dark:text-gray-400 uppercase tracking-wider hidden sm:block">
            Prix Carburants
          </span>
        </div>
      </div>
    </header>
  );
};
